"use strict";
// Copyright (C) 2017-2026 Smart code 203358507
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || (function () {
    var ownKeys = function(o) {
        ownKeys = Object.getOwnPropertyNames || function (o) {
            var ar = [];
            for (var k in o) if (Object.prototype.hasOwnProperty.call(o, k)) ar[ar.length] = k;
            return ar;
        };
        return ownKeys(o);
    };
    return function (mod) {
        if (mod && mod.__esModule) return mod;
        var result = {};
        if (mod != null) for (var k = ownKeys(mod), i = 0; i < k.length; i++) if (k[i] !== "default") __createBinding(result, mod, k[i]);
        __setModuleDefault(result, mod);
        return result;
    };
})();
var __spreadArray = (this && this.__spreadArray) || function (to, from, pack) {
    if (pack || arguments.length === 2) for (var i = 0, l = from.length, ar; i < l; i++) {
        if (ar || !(i in from)) {
            if (!ar) ar = Array.prototype.slice.call(from, 0, i);
            ar[i] = from[i];
        }
    }
    return to.concat(ar || Array.prototype.slice.call(from));
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var react_1 = __importStar(require("react"));
var react_i18next_1 = require("react-i18next");
var classnames_1 = __importDefault(require("classnames"));
var react_2 = __importDefault(require("@stremio/stremio-icons/react"));
var components_1 = require("stremio/components");
var useMediaQuery_1 = __importDefault(require("stremio/common/useMediaQuery"));
var screen_sizes_less_1 = __importDefault(require("stremio/common/screen-sizes.less"));
var EPG_1 = require("stremio/common/EPG");
var DaySelector_less_1 = __importDefault(require("./DaySelector.less"));
var DAYS_BEFORE_TODAY = 3;
var DAYS_IN_RANGE = 7;
var DaySelector = function (_a) {
    var _b;
    var selectedDate = _a.selectedDate, today = _a.today, _c = _a.compact, compact = _c === void 0 ? false : _c, onDayChange = _a.onDayChange;
    var _d = (0, react_i18next_1.useTranslation)(), t = _d.t, i18n = _d.i18n;
    var narrow = (0, useMediaQuery_1.default)("(max-width: ".concat(screen_sizes_less_1.default.xxsmall, ")"));
    var todayDate = (0, react_1.useMemo)(function () { var _a; return (_a = (0, EPG_1.parseEpgDate)(today)) !== null && _a !== void 0 ? _a : new Date(); }, [today]);
    var effectiveDay = (0, react_1.useMemo)(function () { var _a; return (_a = (0, EPG_1.parseEpgDate)(selectedDate)) !== null && _a !== void 0 ? _a : todayDate; }, [selectedDate, todayDate]);
    var days = (0, react_1.useMemo)(function () {
        var range = Array.from({ length: DAYS_IN_RANGE }, function (_, index) {
            return new Date(todayDate.getFullYear(), todayDate.getMonth(), todayDate.getDate() + index - DAYS_BEFORE_TODAY);
        });
        return Array.from(new Set(__spreadArray(__spreadArray([], range.map(function (day) { return day.getTime(); }), true), [effectiveDay.getTime()], false)))
            .sort(function (a, b) { return a - b; })
            .map(function (time) { return new Date(time); });
    }, [todayDate, effectiveDay]);
    var formatters = (0, react_1.useMemo)(function () { return ({
        weekday: new Intl.DateTimeFormat(i18n.language, { weekday: 'short' }),
        date: new Intl.DateTimeFormat(i18n.language, { month: 'short', day: 'numeric' }),
    }); }, [i18n.language]);
    var selectedDayIndex = days.findIndex(function (day) { return day.getTime() === effectiveDay.getTime(); });
    var visibleDayCount = compact ? (narrow ? 1 : 3) : (narrow ? 3 : days.length);
    var firstVisibleDay = Math.max(0, Math.min(days.length - visibleDayCount, selectedDayIndex - Math.floor(visibleDayCount / 2)));
    var visibleDays = days.slice(firstVisibleDay, firstVisibleDay + visibleDayCount);
    var canGoBack = selectedDayIndex > 0;
    var canGoForward = selectedDayIndex < days.length - 1;
    var onPreviousDay = function () {
        if (canGoBack)
            onDayChange(days[selectedDayIndex - 1]);
    };
    var onNextDay = function () {
        if (canGoForward)
            onDayChange(days[selectedDayIndex + 1]);
    };
    return (react_1.default.createElement("div", { className: (0, classnames_1.default)(DaySelector_less_1.default['day-selector'], (_b = {}, _b[DaySelector_less_1.default['compact']] = compact, _b)) },
        react_1.default.createElement(components_1.Button, { className: DaySelector_less_1.default['arrow'], role: 'button', disabled: !canGoBack, "aria-disabled": !canGoBack, tabIndex: canGoBack ? 0 : -1, "aria-label": t('BUTTON_PREV'), onClick: onPreviousDay },
            react_1.default.createElement(react_2.default, { className: DaySelector_less_1.default['arrow-icon'], name: 'chevron-back' })),
        visibleDays.map(function (day) {
            var _a;
            return (react_1.default.createElement(components_1.Button, { key: day.getTime(), className: (0, classnames_1.default)(DaySelector_less_1.default['day'], (_a = {}, _a[DaySelector_less_1.default['active']] = day.getTime() === effectiveDay.getTime(), _a)), role: 'button', onClick: function () { return onDayChange(day); } },
                react_1.default.createElement("div", { className: DaySelector_less_1.default['weekday'] }, formatters.weekday.format(day)),
                react_1.default.createElement("div", { className: DaySelector_less_1.default['date'] }, day.getTime() === todayDate.getTime() ? formatters.date.format(day) : day.getDate())));
        }),
        react_1.default.createElement(components_1.Button, { className: DaySelector_less_1.default['arrow'], role: 'button', disabled: !canGoForward, "aria-disabled": !canGoForward, tabIndex: canGoForward ? 0 : -1, "aria-label": t('BUTTON_NEXT'), onClick: onNextDay },
            react_1.default.createElement(react_2.default, { className: DaySelector_less_1.default['arrow-icon'], name: 'chevron-forward' }))));
};
exports.default = DaySelector;
